import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="site-footer">
            <div className="footer-top">
                <div className="footer-brand">
                    <Link to="/" className="logo">ANDREA LIŠKOVÁ</Link>
                    <p className="footer-tagline">Marketing & Webový design</p>
                </div>
                <div className="footer-links">
                    <div className="footer-column">
                        <h4>NAVIGACE</h4>
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/sluzby">Služby</Link></li>
                        </ul>
                    </div>
                    <div className="footer-column">
                        <h4>KONTAKT</h4>
                        <ul>
                            <li><a href="mailto:info@andrealiskova.cz">info@andrealiskova.cz</a></li>
                            <li><a href="#instagram">Instagram</a></li>
                            <li><a href="#linkedin">LinkedIn</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>© 2026 Andrea Lišková. Všechna práva vyhrazena.</p>
            </div>
        </footer>
    );
}

export default Footer;
